<ng-container *transloco="let t; read 'home.calculator'">
  <ng-container *transloco="let g; read 'home.calculator.map'">
    <div class="relative w-full">

      <div
        class="absolute top-2 right-2 bg-white bg-opacity-90 rounded-2xl z-10 p-4 flex flex-col gap-4 w-[250px] md:w-[350px]"
        *ngIf="!_dataInputDone">
        <ng-container *ngIf="mapState === GoogleMapState.Initial">
          <div class="{{colorConfig.textColor}} font-bold text-xl">
            1. {{ g('choose_location.title') }}
          </div>
          <psc-google-autocomplete
            (setAddress)="setAddress($event)"
            [(ngModel)]="addressValue"></psc-google-autocomplete>
          <psc-button
            @inOutAnimation
            size="small"
            (buttonClicked)="confirmLocation()"
            [type]="colorConfig.primaryButtonType"
            [label]="g('choose_location.confirm_location')">
          </psc-button>
          <div *ngIf="locationNotSelectedError" @inOutAnimation class="text-red-700">
            {{ g('must-select-location') }}
          </div>
        </ng-container>

        <ng-container *ngIf="mapState === GoogleMapState.DrawingRoof">
          <div class="{{colorConfig.textColor}} font-bold text-xl">
            2. {{ g('draw_roof.title') }}
          </div>
          <p class="text-sm text-gray-600">
            {{ g('draw_roof.instruction') }}
          </p>
          <psc-button
            [disabled]="!canFinishDrawing"
            @inOutAnimation
            size="small"
            [type]="colorConfig.primaryButtonType"
            (buttonClicked)="finishDrawing()"
            [label]="g('draw_roof.finish')">
          </psc-button>
          <psc-button
            @inOutAnimation
            size="small"
            [type]="colorConfig.secondaryButtonType"
            (buttonClicked)="startFromBeginning()"
            [label]="g('back')">
          </psc-button>
        </ng-container>

        <ng-container *ngIf="mapState === GoogleMapState.RoofDrawn">
          <div class="{{colorConfig.textColor}} font-bold text-xl">
            {{ g('draw_roof.area_title') }}
          </div>
          <div class="flex items-baseline gap-1">
            <span class="text-3xl font-bold {{colorConfig.textColor}}">{{ drawnAreaM2 | number:'1.0-0' }}</span>
            <span class="text-lg text-gray-500">m²</span>
          </div>
          <p class="text-xs text-gray-500">{{ g('draw_roof.adjust_hint') }}</p>
          <psc-button
            @inOutAnimation
            size="small"
            [type]="colorConfig.secondaryButtonType"
            (buttonClicked)="resetDrawing()"
            [label]="g('draw_roof.redraw')">
          </psc-button>
          <psc-button
            @inOutAnimation
            size="small"
            [type]="colorConfig.primaryButtonType"
            (buttonClicked)="startFromBeginning()"
            [label]="g('start_from_beginning')">
          </psc-button>
        </ng-container>

        <ng-container *ngIf="mapState === GoogleMapState.SolarApiFound">
          <div class="{{colorConfig.textColor}} font-bold text-xl">
            2. {{ g('solar_data_found.title') }}
          </div>
          <psc-button
            @inOutAnimation
            size="small"
            [type]="colorConfig.primaryButtonType"
            (buttonClicked)="cancelSolarDataSelect()"
            [label]="g('back')">
          </psc-button>
        </ng-container>
        <ng-container *ngIf="mapState === GoogleMapState.SolarApiNotFound">
          <div class="{{colorConfig.textColor}} font-bold text-xl">
            2. {{ g('solar_data_not_found.title') }}
          </div>
          {{ g('location_chosen.choice.input_manually') }}
          <psc-button
            @inOutAnimation
            size="small"
            [type]="colorConfig.primaryButtonType"
            (buttonClicked)="startFromBeginning()"
            [label]="g('back')">
          </psc-button>
        </ng-container>

        <div
          *ngIf="buildingInsights && !roofSegmentConfirmed">
          <ng-container *ngIf="selectedRoofSegment; else noSegmentSelected">
            <div class="text-xl">
              {{ g('selected_segment') }}
            </div>
            <div class="my-2 border-b border-gray-500"></div>
            <table class="table-auto">
              <tr>
                <td class="{{colorConfig.textColor}} font-bold pr-2">{{ t('area.title') }}</td>
                <td>{{ selectedRoofSegment.stats.areaMeters2 }}</td>
              </tr>
              <tr>
                <td class="{{colorConfig.textColor}} font-bold pr-2">{{ t('azimuth.title') }}</td>
                <td>{{ selectedRoofSegment.azimuthDegrees }}</td>
              </tr>
              <tr>
                <td class="{{colorConfig.textColor}} font-bold pr-2">{{ t('tilt.title') }}</td>
                <td>{{ selectedRoofSegment.pitchDegrees }}</td>
              </tr>
            </table>
            <div class="flex gap-2 mt-4">
              <psc-button
                size="tiny"
                [type]="colorConfig.primaryButtonType"
                (buttonClicked)="selectCurrentSegment()"
                [label]="g('select_this_segment')"></psc-button>
              <psc-button
                size="tiny"
                type="secondary-magenta"
                (buttonClicked)="closeSegment()"
                [label]="g('cancel')"></psc-button>
            </div>
            <div class="text-gray-500 text-sm">
              *{{ g('select_fills_data') }}
            </div>
          </ng-container>
          <ng-template #noSegmentSelected>
            <div class="mb-3 text-xl">
              {{ g('select_roof_segment') }}
            </div>
          </ng-template>
        </div>
        <div *ngIf="roofSegmentConfirmed">
          {{ g('continue_data_input') }}
        </div>
      </div>
      <!--   Display inline will prevent tha map width to be applied on bigger screens since it's not necessary. Exact width is only required on smaller screens   -->
      <google-map
        class="block md:inline"
        [style.width.px]="innerWidth * 0.95"
        height="700px"
        width="100%"
        [center]="center"
        [options]="mapOptions"
        [zoom]="mapZoom"
        (mapInitialized)="mapInitialized($event)"
        (mapClick)="onMapClick($event.latLng?.toJSON())">
        <map-marker *ngIf="markerPosition" [position]="markerPosition"></map-marker>
        <ng-container *ngFor="let marker of solarApiMarkers; let i = index">
          <map-marker
            [position]="marker.position!"
            [clickable]="true"
            [icon]="marker.icon!"
            (mapClick)="solarApiMarkerClicked(marker, i)"></map-marker>
        </ng-container>
      </google-map>
      <div *ngIf="mapState === GoogleMapState.Initial"
           @inOutAnimation
           (click)="getUserLocation()"
           class="flex cursor-pointer rounded-[2px] bg-white hover:bg-gray-200 transition-all ease-in-out p-2 absolute bottom-[200px] right-[11px]">
        <mat-icon fontIcon="my_location" class="{{colorConfig.textColor}}"></mat-icon>
      </div>
    </div>
  </ng-container>
</ng-container>
